import { useBreakpoint } from '@/hooks/useBreakpoint';

export interface FeatureCardImageProps {
  imageStyle: string;
  imageLink?: string;
  imagePosX?: string;
  imagePosY?: string;
  hideOnMobile?: boolean;
}

const FeatureCardImage: React.FC<FeatureCardImageProps> = ({
  imageStyle,
  imageLink,
  imagePosX,
  imagePosY,
  hideOnMobile,
}) => {
  const styles = imageLink
    ? {
        backgroundImage: `url(${imageLink})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: `${imagePosX}% ${imagePosY}%`,
      }
    : {};

  const { isMobile } = useBreakpoint();

  if (hideOnMobile && isMobile) {
    return;
  }

  return (
    <div
      className={`feature-card__image
      ${imageStyle === 'Contain' ? 'feature-card__image--contain' : ''}`}
      style={styles}
    />
  );
};

export default FeatureCardImage;
